/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: loading-slice.ts
 * Project: mle-client
 * Committed last: 2021/10/25 @ 1138
 * ---
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _                              from 'lodash';
import { LoadingElementsIds }         from '../../common/loading-elements-ids';

export enum LoadingStatuses {
  IDLE = 'IDLE',
  RUNNING = 'RUNNING'
}

export interface LoadingState {
  status: LoadingStatuses,
  targets: LoadingElementsIds[],
  root: boolean
}

const initialState = {
  status: LoadingStatuses.IDLE,
  targets: [],
  root: false
} as LoadingState;

const _loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    runOne(state, action: PayloadAction<LoadingElementsIds>) {
      state.status = LoadingStatuses.RUNNING;
      state.targets.push(action.payload);
    },
    runRoot(state) {
      state.status = LoadingStatuses.RUNNING;
      state.targets = [];
      state.root = true;
    },
    idleOne(state, action: PayloadAction<LoadingElementsIds>) {
      _.pull(state.targets, action.payload);
      if (!state.targets.length)
        state.status = LoadingStatuses.IDLE;
    },
    idleAll(state) {
      Object.assign(state, initialState);
    }
  }
});

export const {
  runOne,
  runRoot, idleAll, idleOne
} = _loadingSlice.actions;
export const loadingSlice = _loadingSlice.reducer;

